import { FullPageSpinner } from '../Spinner';
import { Page } from './Page';

export const EmptyPage = () => (
  <div className='bpm'>
    <div className='bpm-nav-placeholder' />
    <div className='main'>
      <Page title='' pageType=''>
        <FullPageSpinner />
      </Page>
    </div>
  </div>
);
